import { MODEL_PRICING, PROVIDER_COLORS_CSS } from '../data/models';
import { state } from './state';
import { t } from './i18n';
import { escapeHtml, fmtUsd } from './ui-helpers';
import { getSortedModelsByCost, getTotalSpent, getModelTier, getSpent, TIER_LABELS } from './cost-tracking';

export function renderCostLegend() {
  const wrap = document.getElementById("cost-legend");
  if (!wrap) return;
  const sorted = getSortedModelsByCost();
  const total = getTotalSpent();
  const totalChip = total > 0
    ? `<span class="cost-chip" style="background:rgba(0,255,156,0.10); border-color: var(--border-mx);" title="${escapeHtml(t('cost.total.tooltip'))}">
         <span class="cost-chip-name" style="color:var(--matrix); font-weight:600;">Σ ${t('cost.total')}</span>
         <span class="cost-chip-spent" style="border-left: none; margin-left: 0;">${fmtUsd(total)}</span>
       </span>`
    : "";
  let html = `<span class="cost-legend-label">${t('cost.legend')}</span>`;
  sorted.forEach((m, i) => {
    const tier = getModelTier(m.id);
    const sp = getSpent(m.id);
    const isSelected = state.selectedModels.has(m.id);
    const spStr = sp > 0 ? `<span class="cost-chip-spent">${fmtUsd(sp)}</span>` : "";
    const cls = "cost-chip" + (isSelected ? " selected" : "");
    const p = MODEL_PRICING[m.id];
    const title = p ? `${m.label} — ${fmtUsd(p.in)}/M in · ${fmtUsd(p.out)}/M out` : m.label;
    html += `<span class="${cls}" data-cost-chip="${m.id}" title="${escapeHtml(title)}">
      <span class="cost-chip-dot" style="background:${PROVIDER_COLORS_CSS[m.provider]}"></span>
      <span class="cost-chip-name">${escapeHtml(m.label)}</span>
      <span class="cost-chip-tier cost-tier-${tier}">${TIER_LABELS[tier]}</span>
      ${spStr}
    </span>`;
  });
  html += totalChip;
  wrap.innerHTML = html;
  // Click on a chip toggles selection (mirrors the constellation node)
  wrap.querySelectorAll("[data-cost-chip]").forEach(chip => {
    chip.addEventListener("click", () => {
      const id = chip.dataset.costChip;
      // Dispatch a selection-toggle event consumed by constellation/runner.
      window.dispatchEvent(new CustomEvent("lp-toggle-model", { detail: { modelId: id } }));
    });
  });
}
